//
//
//
//
//
//
//

import InventoryCard from './InventoryCard.vue'
import AddSkillsCard from './AddSkillsCard.vue'
import SectionCards from '~/components/Dashboard/Employee/SectionCards.vue'

export default {
  components: {
    InventoryCard,
    AddSkillsCard,
    SectionCards,
  },
  props: {
    permissions: {
      type: Object,
      default: () => ({
        isEnabledInventorySkills: false,
        isEnabledMatchPotential: false,
        isEnabledKitOfSkills: false,
      }),
    },
  },
}
